<template>
  <div>
    <config-bar></config-bar>
    <div class="container">
      <div class="card mt-3">
        <div class="container-fluid">
          <form id="formRede" class="mt-3">
            <div class="form-group">
              <label for="ip">IP</label>
              <input
                type="text"
                class="form-control"
                id="ip"
                name="ip"
                placeholder="192.168.1.101"
                required
                pattern="(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*){3}"
                v-model="rede.ip"
              />
            </div>
            <div class="form-group">
              <label for="gateway">Gateway</label>
              <input
                type="text"
                class="form-control"
                id="gateway"
                name="gateway"
                placeholder="192.168.1.1"
                required
                pattern="(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*){3}"
                v-model="rede.gateway"
              />
            </div>
            <div class="form-group">
              <label for="mask">Mascara</label>
              <input
                type="text"
                class="form-control"
                id="mask"
                name="mask"
                placeholder="255.0.0.0"
                required
                pattern="(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*){3}"
                v-model="rede.mask"
              />
            </div>
            <div class="form-group">
              <label for="dns1">DNS</label>
              <input
                type="text"
                class="form-control"
                id="dns1"
                name="dns1"
                placeholder="8.8.8.8"
                pattern="(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)_*){3}"
              />
            </div>
          </form>
          <button class="btn btn-primary mb-3" @click="save">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import API from "../../utils/api";
import ConfigBar from "./ConfigBar";
let $api;
export default {
  data() {
    return {
      rede: {
        ip: "",
        gateway: "",
        mask: "",
        dns1: ""
      }
    };
  },
  mounted() {
    $api = new API();
    $api.getConfigRede().then(({ data }) => (this.rede = data));
  },
  methods: {
    save() {
      let fRede = document.querySelector("#formRede");
      if (!fRede.checkValidity()) {
        fRede.reportValidity();
        return;
      }
      if (confirm("Tem certeza?"))
        $api.sendConfigRede(this.rede).finally(() => {
          if (
            confirm(
              "Mudanças executadas! Deseja ser redirecionado para o novo ip?"
            )
          )
            setTimeout(() => {
              window.location.href = `http://${this.rede.ip}`;
            }, 3000);
        });
    }
  },
  components: {
    ConfigBar
  }
};
</script>

<style>
</style>